import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function FlashDrought() {
	return (
		<>
			<Paper elevation={3} sx={{ p: 2 }}>
				<h3>What is Flash Drought</h3>
				<p>Definition: An unusually rapid onset drought event characterized by relatively 
					short periods of hot weather and anomalously low/decreasing soil moisture, 
					that culminates in impacts to one or more sectors. Rapid drought development 
					(“flash drought”) may occur when week 2-4 forecasts indicate: </p>
				<ul>
					<li>Negative soil moisture anomalies</li>
					<li>Positive temperature anomalies</li>
					<li>Negative precipitation anomalies (or no precipitation forecast)</li>
					<li>Rapid onset drought is often co-located with areas experiencing extreme heat</li>
				</ul>
			</Paper>

			<Typography
				variant="body1"
				sx={{ p:1, mx:2, border:"1pt solid gray", backgroundColor:"#f2f2f2" }}
			>
				Provided by Sarah Jamison, NWS GYX
				<p>See also: Otkin, J. A., M. Svoboda, E. D. Hunt, T. W. Ford, M. C. Anderson, C. Hain, and J. B. Basara, 2018: &nbsp;<a href="https://journals.ametsoc.org/view/journals/bams/99/5/bams-d-17-0149.1.xml" target="_blank" rel="noopener noreferrer">
				Flash Droughts: A Review and Assessment of the Challenges Imposed by Rapid-Onset Droughts in the United States.</a> <i>Bull. Amer. Meteor. Soc.</i>, 99, 911-919.
				</p>
			</Typography>
	   </>
	);
}